import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { SharedService } from '../../shared.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { OnlineApplicationService} from '../online_application.service'
import * as moment from 'moment';

@Component({
    selector: 'app-online-application-home',
    templateUrl: './online_application_home.component.html',
})

export class OnlineApplicationHomeComponent implements OnInit, OnDestroy {

    images = [];
    currentSlide = 0

    admission_details : any;
    admission_classes = []
    admision_year = ""

    school_logo = null;
    admission_open = {"status" : true};
    enable_image_view = false;

    application_view_status = 1

    today = new Date()

    ApplicationMainForm = this.fb.group({
        student_class : [null],
        student_dob : [null],
        application_number : [""]
    })

    get f(){
        return this.ApplicationMainForm.controls;
    }

    constructor(
        private fb: UntypedFormBuilder,
        public translate: TranslateService,
        private router: Router,
        private shareService: SharedService,
        private onlineApplicationService : OnlineApplicationService,
        private toastr: ToastrService,
    ) { }

    onSubmit() {
    }

    ngOnInit() {
        this.getSliderImages();
        setInterval(() => this.callNextSlide(), 10000);
        this.getAdmissionDetails()
        this.getAdmissionEnable();
        this.getSchoolLogo();
        this.getActiveAdmissionYear();
    }

    getActiveAdmissionYear(){
        this.onlineApplicationService.getOnlineApplicationInfos({search_type : "active_admission_year"}).subscribe(response=>{
            this.admision_year = response["admission_year"]
        })
    }

    callNextSlide(){
        if(this.images?.length > 0){
            this.nextSlide();
        }
    }

    getAdmissionDetails(){
        this.onlineApplicationService.getOnlineApplicationInfos({search_type : "application_form", type : 'admission_details'}).subscribe(response=>{
            this.admission_details = response["data"]
            this.admission_classes = this.admission_details["available_classes"].replace("[",'').replace("]",'').replaceAll(" '","").replaceAll("'","").split(',')
        })
    }
    
    getAdmissionEnable(){
        this.onlineApplicationService.getOnlineApplicationInfos({search_type : "application_form", type : 'admission_status'}).subscribe(response=>{
            this.admission_open = response["data"]
        })
    }

    getSchoolLogo(){
        this.onlineApplicationService.getOnlineApplicationInfos({search_type : "application_form", type : 'school_logo'}).subscribe(response=>{
            this.school_logo =  response["data"]
        })
    }

    getSliderImages(){
        this.onlineApplicationService.getOnlineApplicationInfos({search_type : "application_form",  type : "slider_images"}).subscribe(response=>{
            this.images = response["data"];
            if(this.images.length > 0){
                this.currentSlide = 0
                this.enable_image_view = true;
            }
        })
    }

    ngOnDestroy(): void { }


    nextSlide() {
        this.currentSlide = (this.currentSlide + 1) % this.images.length;
    }

    prevSlide() {
        this.currentSlide = this.currentSlide > 0 ? this.currentSlide - 1 : this.images.length - 1;
    }

    applyApplicationForm(){
        this.application_view_status = 2
    }

    checkApplicationStatus(){
        this.application_view_status = 3
    }

    cancelAdmission(){
        this.application_view_status = 1
    }

    formatDate(date){
        if(date){
            return moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD');
        }else{
            return null;
        }
    }

    checkStudentAgeValidity(){
        if(this.ApplicationMainForm.value["student_class"] && this.ApplicationMainForm.value["student_dob"]){
            this.onlineApplicationService.checkOnlineApplicationInfos({
                student_class : this.ApplicationMainForm.value["student_class"],
                student_dob : this.formatDate(this.ApplicationMainForm.value["student_dob"]),
                type : "application_class_age",
                post_type : "application_form_settings"
            }).subscribe(response=>{
                if(response["status"] == 1){
                    this.router.navigate(['/school_application_form/apply/'],{queryParams : 
                        {
                            student_class : this.ApplicationMainForm.value["student_class"],
                            student_dob : this.formatDate(this.ApplicationMainForm.value["student_dob"])
                        }
                    })
                }else{
                    Swal.fire({
                        icon: 'error',
                        text: this.translate.instant(response["message"]),
                        confirmButtonText: 'Okay'
                    })
                }
            },error=>{this.toastr.error(error.error["message"])})
        }else{
            this.toastr.error("Please Select Class and DOB!")
            return
        }
    }

    getResistartionStatus(){
        if(this.ApplicationMainForm.value["application_number"] && this.ApplicationMainForm.value["student_dob"]){
            this.onlineApplicationService.getOnlineRegistartionStatus({
                application_number : this.ApplicationMainForm.value["application_number"], 
                student_dob : this.formatDate(this.ApplicationMainForm.value["student_dob"]),
                search_type : "application_status"
            }).subscribe(response=>{
                if(response["status"] == 2){
                    Swal.fire({
                        icon: 'warning',
                        text: this.translate.instant(response["message"]),
                        confirmButtonText: 'Okay'
                    })
                }else if(response["status"] == 1){
                    Swal.fire({
                        icon: 'success',
                        text: this.translate.instant(response["message"]),
                        confirmButtonText: 'Okay'
                    })
                }else{
                    Swal.fire({
                        icon: 'error',
                        text: this.translate.instant(response["message"]),
                        confirmButtonText: 'Okay'
                    })
                }
            })
        }
    }


}
